<template>
  <a-drawer
    :visible="visible"
    title="Selecciona tus filtros por gestión"
    placement="right"
    width="480"
    keyboard
    :body-style="{ padding: 0 }"
    :maskClosable="false"
    @close="handleHideDrawer"
  >
    <custom-scrollbar height="calc(100vh - 72px - 48px)">
      <div class="modal__body">
        <p class="drawer__body--subtitle" v-if="filterAdvanced.groups?.length > 0 && campaignId">
          Filtra tus contactos en base a sus gestiones realizadas. No olvides aplicar tus filtros
          para que se visualicen en la tabla.
        </p>
        <p class="drawer__body--subtitle" v-else>
          Filtra tus contactos en base a sus gestiones realizadas.
        </p>

        <div
          v-if="filterAdvanced.groups?.length > 0 && campaignId && basicFilters.coverage === 'True'"
        >
          <a-form layout="vertical">
            <drawer-subtitle class="drawer__body--title"> Datos generales </drawer-subtitle>

            <a-form-item label="Contactos con productos" name="products">
              <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="formState.products"
              >
                <a-select-option :key="1">Todos los contactos</a-select-option>
                <a-select-option :key="2">Contactos con productos</a-select-option>
                <a-select-option :key="3">Contactos sin productos</a-select-option>
              </a-select>
            </a-form-item>

            <drawer-subtitle
              class="drawer__body--title"
              v-if="filterAdvanced.groups?.length > 0 && campaignId"
            >
              Tipificaciones
            </drawer-subtitle>
            <a-form-item label="Tipo" name="type_size">
              <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="formState.typificationType"
              >
                <a-select-option :key="1">Última y mejor tipificación</a-select-option>
                <a-select-option :key="2">Mejor tipificación del mes</a-select-option>
                <a-select-option :key="3">Última tipificación</a-select-option>
              </a-select>
            </a-form-item>
            <client-filters-input
              :value="filters.groups"
              @update:value="handleSelectedGroup"
              :items="filterAdvanced.groups || []"
              label="Grupos"
            />
            <client-filters-input
              :value="filters.results"
              @update:value="handleSelectedResult"
              :items="resultsFilters"
              label="Resultado"
            />

            <drawer-subtitle class="drawer__body--title">
              Asignación de contactos:
            </drawer-subtitle>
            <a-form-item label="Tipo de vista" name="products">
              <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="formState.assigned"
              >
                <a-select-option :value="''"> Contactos asignados y no asignados </a-select-option>
                <a-select-option :key="1"> Solo contactos asignados </a-select-option>
              </a-select>
            </a-form-item>
          </a-form>

          <template v-if="userData?.profile !== ProfileTypes.Agent">
            <drawer-subtitle class="drawer__body--title">
              Última vez gestionado por:
            </drawer-subtitle>
            <users-picker
              :value="filters.users"
              @update:value="filters.users = $event"
              :items="filterAdvanced?.users || []"
            />
          </template>

          <drawer-subtitle class="drawer__body--title"> Fecha de última gestión </drawer-subtitle>
          <client-filters-date :value="filters.dates" @update:value="filters.dates = $event" />
        </div>

        <section v-else>
          <div
            class="container__empty"
            v-if="(entityId > 0 && campaignId === null) || entityId === null"
          >
            <img :src="maskGroupImage" alt="maskgroup" />
            <p class="text--top">Debes seleccionar una sola empresa y</p>
            <p class="text--bottom">campaña para utilizar esta opción.</p>
          </div>
          <div class="container__empty" v-else>
            <img :src="maskGroupImage" alt="maskgroup" />
            <p>Podrás utilizar esta opción cuando tengas</p>
            <p>gestiones realizadas.</p>
          </div>
        </section>
      </div>
    </custom-scrollbar>

    <div class="footer">
      <div class="footer__display" v-if="disabledFilters">Recuerda aplicar los cambios</div>
      <a-button class="footer__button" @click="handleClearDrawer" :disabled="!disabledFilters">
        Limpiar
      </a-button>
      <a-button type="primary" @click="handleApplyFilters" :disabled="!disabledFilters">
        Aplicar
      </a-button>
    </div>
  </a-drawer>
</template>
<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import ClientFiltersInput from "@/app/contacts/components/drawers/ClientFiltersInput.vue";
import UsersPicker from "@/app/contacts/components/pickers/UsersPicker.vue";
import DrawerSubtitle from "@/app/contacts/components/drawers/DrawerSubtitle.vue";
import ClientFiltersDate from "@/app/contacts/components/drawers/ClientFiltersDate.vue";
import { ProfileTypes } from "@/app/shared/utils/enums";
import { defineComponent, reactive, inject } from "vue";

import maskGroupImage from "@/app/contacts/assets/maskGroup.svg?url";

export default defineComponent({
  components: {
    CustomScrollbar,
    UsersPicker,
    ClientFiltersInput,
    DrawerSubtitle,
    ClientFiltersDate,
  },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
  },
  setup() {
    const formState = reactive({
      typificationType: 1,
      products: 1,
      assigned: "",
    });

    const loadingTableData = inject("loadingTableData");

    const selectedTableRowKeys = inject("selectedTableRowKeys");
    const selectedRowsList = inject("selectedRowsList");
    const selectedAll = inject("selectedAll");

    return {
      formState,
      loadingTableData,
      ProfileTypes,
      maskGroupImage,
      selectedTableRowKeys,
      selectedRowsList,
      selectedAll,
    };
  },
  data() {
    return {
      filters: {
        groups: [],
        results: [],
        users: [],
        dates: [],
      },
      // resultsFilters: [],
      selectedGroup: undefined,
      selectedResults: undefined,
      searchUsers: false,
      campaignIdFilter: undefined,
      advancedFiltersData: {},
    };
  },
  computed: {
    userData() {
      return this.$store.getters["getDataUser"];
    },
    filterAdvanced() {
      return this.$store.getters["getFilterAdvanced"];
    },
    basicFilters() {
      return this.$store.getters["getBasicFilters"];
    },
    entityId() {
      return this.$store.getters["getBasicFilters"].entity;
    },
    campaignId() {
      return this.$store.getters["getBasicFilters"].campaign;
    },
    baseId() {
      return this.$store.getters["getBasicFilters"].base;
    },
    disabledFilters() {
      return this.filterAdvanced.groups?.length > 0 && this.campaignId;
    },
    resultsFilters() {
      const dataGlobal = this.filterAdvanced.results;
      const a = [];

      this.filters.groups.forEach((el) => {
        const getId = el;
        dataGlobal.forEach((result) => {
          const resultsGroup = result.group;

          if (getId === resultsGroup) {
            a.push(result);
          }
        });
      });
      return a;
    }
  },
  watch: {
    campaignId(value) {
      if (value) {
        this.$store.dispatch("fetchAdvancedFilters", value);
        this.handleReset();
      }
    },
  },
  methods: {
    handleReset() {
      this.filters = {
        groups: [],
        results: [],
        users: [],
        dates: [],
      };
      this.selectedGroup = [];
      this.selectedResults = [];
    },
    handleSendTypificatioType(value) {
      this.$emit("onTypificationType", value);
    },
    async handleHideDrawer() {
      // this.loadingTableData = true;
      // await this.$store.dispatch("fetchContacts", { filters: this.basicFilters });
      this.handleCloseDrawer();

      // this.loadingTableData = false;
    },
    handleCloseDrawer() {
      // this.resultsFilters = [];
      this.filters.users = [];
      this.$emit("update:visible", false);
    },
    async handleApplyFilters() {
      this.selectedTableRowKeys = [];
      this.selectedRowsList = [];
      this.selectedAll = false;

      this.advancedFiltersData = {
        coverage: "True",
        entity_id: this.entityId,
        base_id: this.baseId || undefined,
        portfolio_id: this.campaignId || 1,
        groups_id: this.selectedGroup,
        results_id: this.selectedResults,
        users_id: this.filters.users.map((user) => user.id),
        typification_type: this.formState.typificationType,
        has_products: this.formState.products,
        assigned: this.formState.assigned,
      };

      if (this.filters.dates[0]) {
        this.advancedFiltersData.last_management_date_start = `${this.filters.dates[0]} 00:00:00`;
      }
      if (this.filters.dates[1]) {
        this.advancedFiltersData.last_management_date_end = `${this.filters.dates[1]} 23:59:59`;
      }

      const isAdvancedEmpty =
        this.advancedFiltersData.groups_id?.length === 0 &&
        this.advancedFiltersData.results_id?.length === 0 &&
        this.advancedFiltersData.users_id?.length === 0 &&
        !this.advancedFiltersData.last_management_date_start &&
        !this.advancedFiltersData.last_management_date_end &&
        this.advancedFiltersData.typification_type === 1 &&
        this.advancedFiltersData.has_products === 1 &&
        !this.advancedFiltersData.assigned;

      this.loadingTableData = true;
      if (isAdvancedEmpty) {
        await this.$store.dispatch("fetchContacts", { filters: this.basicFilters });
      } else {
        const { has_products, assigned, ...advancedFilters } = this.advancedFiltersData;

        if (has_products !== 1) advancedFilters.has_products = has_products === 2;
        if (assigned) advancedFilters.assigned = assigned;

        this.$store.commit("SET_ADVANCED_FILTERS", advancedFilters);
        await this.$store.dispatch("applyAdvancedFilters", {
          filters: advancedFilters,
          pagination: { current: 1 },
        });
      }
      this.loadingTableData = false;

      this.$store.commit("SET_CURRENT_TABLE_PAGE", 1);
      this.$emit("update:visible", false);
    },
    async handleClearDrawer() {
      // this.resultsFilters = [];
      this.filters.users = [];
      this.filters.dates = [];
      this.handleReset();
      this.formState.typificationType = 1;
      this.formState.products = 1;
      this.advancedFiltersData = {};

      this.loadingTableData = true;

      this.$store.commit("SET_ADVANCED_FILTERS", this.advancedFiltersData);

      await this.$store.dispatch("fetchContacts", { filters: this.basicFilters });
      // await this.$store.dispatch("applyAdvancedFilters", {
      //   filters: this.advancedFiltersData,
      //   pagination: { current: 1 },
      // });

      this.loadingTableData = false;
      this.$emit("update:visible", false);
    },
    // TODO: REFACTOR
    handleSelectedGroup(e) {
      const a = [];
      this.selectedGroup = [];
      const troncos = e;
      // const dataGlobal = this.filterAdvanced.results;

      troncos.forEach((name) => {
        const getId = name.id;
        this.selectedGroup.push(name.id);
        // dataGlobal.forEach((result) => {
        //   const resultsGroup = result.group;

        //   if (getId === resultsGroup) {
        //     a.push(result);
        //   }
        // });
      });
      // this.resultsFilters = a;
      this.filters.groups = this.selectedGroup;
    },
    handleSelectedResult(results) {
      this.selectedResults = [];

      results.forEach((result) => {
        this.selectedResults.push(result.id);
      });

      this.filters.results = this.selectedResults;
    },
  },
});
</script>
<style lang="sass" scoped>
.modal
  &__body
    margin: 12px 24px

.footer
  display: flex
  align-items: center
  justify-content: flex-end
  margin-top: 8px
  padding: 12px 16px
  border-top: $border-normal

  &__display
    width: 100%
    font-size: 12px
    color: $gray-7

  &__button
    margin-right: 12px

.ant-form-item
  margin-bottom: 4px

.drawer__body
  &--title
    font-weight: 600
    color: $gray-9

  &--subtitle
    font-weight: 400
    color: $gray-8

.container__empty
  text-align: center
  margin-top: 210px

.text--bottom
  margin-top: 0

.text--top
  margin-top: 20px
  margin-bottom: 0
</style>
